var React = require('react');

function BlueArrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"40","cy":"40","r":"40","fill":"#EDF8FF","key":0}),React.createElement("path",{"d":"M19 40.8182L29.1768 51.3034C31.1408 53.3269 34.3886 53.3269 36.3526 51.3034L58 29M58 29H42.8588M58 29V44.1273","stroke":"#2665F6","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

BlueArrow.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = BlueArrow;

BlueArrow.default = BlueArrow;
